export default class GenerateDataZoomUtil {
  static generateDataZoom(
    {
      dataCount,
      orient,
      showDataShadow,
      width,
      right = 'auto',
      left = 'auto',
      height,
      yAxisIndex,
      x
    }:
      {
        dataCount: number;
        orient: string;
        showDataShadow: boolean;
        width?: number;
        right?: string | number;
        left?: string | number;
        height?: number;
        yAxisIndex?: number;
        x: number;
      }) {
    let returnVal: any;

    if (dataCount < x) {
      return [];
    }

    const y = Math.floor(x / dataCount * 100);

    returnVal = {
      orient,
      type: 'slider',
      show: true,
      showDataShadow,
      showDetail: false,
      handleSize: '100%',
      start: 100 - y,
      end: 100,
      maxSpan: y,
      right,
      left
    };

    if(height){
      returnVal = {...returnVal, height};
    }

    if(width){
      returnVal = {...returnVal, width};
    }

    if(yAxisIndex){
      returnVal = {...returnVal, yAxisIndex};
    }

    return [returnVal];
  }
}
